/********************************************************************
 * Project: WDCK（2021）
 * Class: ConsulnumDirective
 * ----------------------------------------
 * <summary>
 * 
 * </summary>
 * <history>
 *      NghiaTQ     2021/09/21      Create
 * </history>
 ********************************************************************/
import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[consulNum]',
})
export class ConsulnumDirective {
    regex = /[^0-9*/~]/g;

    constructor(private el: ElementRef) {
    }
    @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
        e.preventDefault();
    }

    @HostListener('input', ['$event']) onInputChange(event) {
        const initalValue = this.el.nativeElement.value;
        this.el.nativeElement.value = initalValue.replace(this.regex, '');
        if (initalValue !== this.el.nativeElement.value) {
            event.stopPropagation();
        }
    }
}
